import React from 'react';

type UploadTemplate = {
  filename: string;
  headers: string[];
  // columns not listed here are treated as optional
  requiredHeaders: string[];
  exampleRow: string[];
};

export const CATEGORY_TEMPLATE: UploadTemplate = {
  filename: 'category_upload_template.csv',
  headers: ['title', 'externalAccountId'],
  requiredHeaders: ['title', 'externalAccountId'],
  exampleRow: ['Office Supplies', 'ACC-001'],
};

export const CUSTOM_FIELD_OPTIONS_TEMPLATE: UploadTemplate = {
  filename: 'custom_field_options_template.csv',
  headers: ['name', 'status'],
  requiredHeaders: ['name'],
  exampleRow: ['Option Name', 'active'],
};

export const DEPARTMENT_TEMPLATE: UploadTemplate = {
  filename: 'department_upload_template.csv',
  headers: ['Department Name', 'External ID'],
  requiredHeaders: ['Department Name'],
  exampleRow: ['Engineering', 'DEPT-001'],
};

export const TRANSACTION_TEMPLATE: UploadTemplate = {
  filename: 'transaction_upload_template.csv',
  headers: [
    'Transaction Date',
    'Posted Date',
    'Merchant',
    'Amount',
    'Card Last Four',
    'First 6 of card',
    'Card Holder Name',
    "User's Email Address",
    'Currency Code',
  ],
  requiredHeaders: ['Transaction Date', 'Posted Date', 'Merchant', 'Amount', 'Card Last Four'],
  exampleRow: ['2024-01-15', '2024-01-16', 'Example Merchant', '50.00', '1234', '411111', 'Jane Doe', 'jane.doe@example.com', 'USD'],
};

export function TemplateTooltipContent({ template }: { template: UploadTemplate }) {
  const required = new Set(template.requiredHeaders);
  return (
    <div>
      {template.headers.map((h) => (
        <div key={h} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '2px 0' }}>
          <span style={{ fontSize: 12 }}>{required.has(h) ? '✓' : '○'}</span>
          <span>{h}</span>
          {required.has(h) ? (
            <span style={{ fontSize: 11, opacity: 0.75 }}>(required)</span>
          ) : (
            <span style={{ fontSize: 11, opacity: 0.75 }}>(optional)</span>
          )}
        </div>
      ))}
    </div>
  );
}

export function downloadCSVTemplate(template: UploadTemplate): void {
  const escape = (val: string) =>
    val.includes(',') || val.includes('"') || val.includes('\n')
      ? `"${val.replace(/"/g, '""')}"`
      : val;
  const csv = [
    template.headers.map(escape).join(','),
    template.exampleRow.map(escape).join(','),
  ].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', template.filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
